import { create } from 'zustand';

interface PaywallTermsCheckboxState {
  isChecked: boolean;
  isHighlighted: boolean;
  setChecked: (checked: boolean) => void;
  setHighlighted: (highlighted: boolean) => void;
  reset: () => void;
}

export const usePaywallTermsCheckbox = create<PaywallTermsCheckboxState>(
  (set) => ({
    isChecked: false,
    isHighlighted: false,
    setChecked: (checked: boolean) => set({ isChecked: checked }),
    setHighlighted: (highlighted: boolean) =>
      set({ isHighlighted: highlighted }),
    reset: () => set({ isChecked: false, isHighlighted: false }),
  }),
);

export const PAYWALL_TERMS_CHECKBOX_ID = 'paywall-terms-checkbox';
